import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import axios from 'axios';
import * as moment from 'moment';
import { ENDPOINTS, USER_ROLES_TRANSLATIONS } from '../app.config';
import Utils from '../app.utilities';
import { CompanyService } from 'app/company.service';
import { TranslateService } from '@ngx-translate/core';

const utilities = new Utils();

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  exactTime: string;
  userRole: string;
  showDropDown: boolean;
  showChangePassword: boolean;
  executingSeconds: number;
  showMenu: string;
  router: Router;
  toaster: ToasterService;
  companyId: any;
  langs: string[];

  constructor(router: Router, toaster: ToasterService, private companyService: CompanyService,
              private translate: TranslateService) {
    this.showDropDown = false;
    this.showChangePassword = false;
    this.router = router;
    this.toaster = toaster;
    this.executingSeconds = 1;
    this.showMenu = 'no';
  }

  ngOnInit() {
    this.langs = this.translate.getLangs();
    const _self = this;
    this.getServerTime();
    this.getUserRole();
    this.companyService.getCompanyId().subscribe(companyId => {
      _self.companyId = companyId;
    });
  }

  toggleMenu() {
    this.showMenu = this.showMenu === 'yes' ? 'no' : 'yes';
  }

  activateTimeInterval(serverTime) {
    const _self = this;
    setInterval(() => {
      const dateTime = serverTime.split(' ');
      const date = dateTime[0].split('-');
      const configuredTime =
        date[2] + '/' + date[1] + '/' + date[0] + ' ' + dateTime[1];
      const now = new Date(configuredTime);
      now.setSeconds(now.getSeconds() + this.executingSeconds);
      _self.exactTime = moment(now).format('DD.MM.YYYY HH:mm:ss');
      this.executingSeconds += 1;
    }, 1000);
  }

  getServerTime() {
    const _self = this;
    axios.get(ENDPOINTS.GET_SERVER_TIME).then(
      response => {
        const dateTime = response.data.now.split(' ');
        const date = dateTime[0].split('-');
        _self.exactTime =
          date[0] + '.' + date[1] + '.' + date[2] + ' ' + dateTime[1];
        this.activateTimeInterval(response.data.now);
      },
      errorGettingUser => {
        _self.exactTime = '';
        this.toaster.pop('error', 'Error getting time');
      },
    );
  }

  getUserRole() {
    axios.get(ENDPOINTS.GET_CURRENT_USER).then(
      responseUser => {
        this.userRole =
          utilities.getUserRole(responseUser.data);
      },
      errorGettingUser => {
        this.toaster.pop('error', 'Error getting current user');
      },
    );
  }

  toggleDropdownMenu() {
    this.showDropDown = !this.showDropDown;
  }

  navigateToAdmin() {
    this.showDropDown = false;
    this.router.navigate(['/admin'])
  }

  logout() {
    utilities.clearAppStorage();
    this.showDropDown = false;
    this.router.navigate(['']);
  }

  navigateToHelp() {
    this.router.navigate(['/help', this.companyId])
  }

  onChangeLang(lang: string) {
    this.translate.use(lang);
  }
}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/header/header.component.ts